import React from 'react';
import { Badge, Card, Divider,  Flex,  Paper,  Text,  Title } from '@mantine/core';
import ListInfoBlock from './ListInfoBlock';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
const CardBlock = ({
  data = {}
}) => {
  const detailBlockContent = [
    { label: 'Tanggal Terblokir', value: <Text fw={500} fz={18}>{data?.blockedAt ? dayjs(data?.blockedAt).locale('id').format('DD MMMM YYYY') : '-'}</Text> },
    // custom bg & color for rejected
    //  | b="#FBE5E6"
    { label: 'Alasan Diblokir', value: <Paper bg="#FBE5E6" fw={500} fz={18} p={8} radius={8}>
      {data?.blockedReason || '-'}
    </Paper> },
    { label: 'Keterangan', value: <Paper bg="#FBE5E6" fw={500} fz={18} p={8} radius={8}>
      {data?.blockedReasonDetail || '-'}
    </Paper> },
  ];
  return (
    <Card h="100%" withBorder>
      <Flex align="center" justify="space-between">
        <Title order={5}>Rincian Blokir</Title>
        <Badge bg="#E0F3FE" c="#0F6EB5" fw={500} tt="none">{data?.blockedType === 1 ?
          'Diblokir Sistem' : 'Diblokir Oleh Admin DC'}</Badge>
      </Flex>
      {detailBlockContent.map((item,idx) => (
        <React.Fragment key={idx}>
          <ListInfoBlock label={item.label} value={item.value} />
          {idx < detailBlockContent.length - 1 && <Divider my="sm" />}
        </React.Fragment>
      ))}
    </Card>
  );
};

export default CardBlock;

CardBlock.propTypes = {
  data: PropTypes.object
};
